var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4a.724.724 0 0 1-.471-.167L.196.975a.516.516 0 0 1 0-.808.747.747 0 0 1 .942 0L4 2.621 6.862.168a.747.747 0 0 1 .943 0c.26.223.26.585 0 .808L4.472 3.833A.725.725 0 0 1 4 4Z",
    fill: "currentColor"
  })));
};

export default SvgArrowDown;